<script>
import { mapActions, mapState } from 'vuex'
import { required } from 'vuelidate/lib/validators'

export default {
  name: 'SignIn',
  components: {
    Action: () => import('@/components/general/Action'),
    InputField: () => import('@/components/general/InputField'),
    Logo: () => import('@/components/general/Logo')
  },

  data () {
    return {
      username: null,
      password: null,
      isDesktop: true
    }
  },

  validations: {
    username: {
      required
    },

    password: {
      required
    }
  },

  computed: {
    ...mapState([ 'accessibility' ])
  },

  created () {
    this.isDesktop = !this.$media.mobile
  },

  methods: {
    ...mapActions([
      'setFeedback',
      'setFetching',
      'attemptSignIn',
      'attemptGetLoggedUser'
    ]),

    submit () {
      this.$v.$touch()

      if (!this.$v.$invalid) {
        const { username, password } = this

        this.setFetching(true)

        this.attemptSignIn({
          username,
          password
        })
          .then(() => {
            this.attemptGetLoggedUser().then(() => {
              this.$router.push({ name: 'solutions.index' })
            })
          })
          .catch(() => {
            this.setFeedback({ message: this.$t('global:auth.error') })
            this.resetForm()
          })
          .finally(() => {
            this.setFetching(false)
          })
      }
    },

    resetForm () {
      this.$v.$reset()
      this.username = null
      this.password = null
    }
  }
}
</script>

<template>
  <div class="main-content auth">
    <div class="center clearfix">
      <div class="form">
        <form
          class="login-form"
          @submit.prevent="submit"
        >
          <InputField
            v-model="username"
            :label="$t('global:form.username')"
            type="text"
            autocomplete="username"
            autocapitalize="none"
            :validation="$v.username"
            dark
          />
          <InputField
            v-model="password"
            :label="$t('global:form.password')"
            type="password"
            autocomplete="current-password"
            :validation="$v.password"
            dark
          />
          <div class="form-submit">
            <Action
              v-if="isDesktop"
              type="button"
              :text="$t('auth.signin:form.submit')"
              submit
              secondary
              large
              fixed-width
              dark
            />
          </div>
        </form>
      </div>
      <div class="company">
        <Logo
          class="company-logo"
          :theme="$theme"
        />
      </div>
    </div>
  </div>
</template>

<style src="@/assets/styles/themes/default/auth.css"></style>
